import { pathOr } from 'ramda'

export const getPromotions = state =>
  pathOr(null, ['api', 'subscription', 'info', 'promotionActivations'], state)
